import * as React from 'react';
import styles from './modal.module.css';

export type TModalProps = {
	id: string;
	title: string;
	body: JSX.Element;
	footer: JSX.Element;
	onCloseModalClick?: any;
};

export const Modal: React.StatelessComponent<TModalProps> = props => (
	<div className={styles.overlayFixed} aria-labelledby="modal-title" role="dialog" aria-modal="true">
		<div className={styles.overlayFlex}>
			<div className={styles.overlayFixedInset} aria-hidden="true"></div>
			<div className={styles.overlayBg}>
				<div className={styles.fontRoboto}>
					<div className={styles.overlayBgBlue}>
						<h3 className={styles.overlayTitle}>{props.title}</h3>
						<button
							type="button"
							data-dismiss="modal"
							aria-label="Close"
							className={styles.closeBtn}
							onClick={props.onCloseModalClick}>
							X
						</button>
					</div>
					<div className={styles.overlayBody}>
						<div className={styles.overlayBodyText} id={props.id}>
							{props.body}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);
